<template>
    <div class="wp">
        <div class="w-1200 communication-detail-1">
            <div class="title-more">
                <i class="el-icon-s-home" style="color:#615E61;position:relative;top:16px;left:10px;"> </i>
                <el-breadcrumb style="width:90%;padding-left:40px;"  separator=" - ">
                    <el-breadcrumb-item :to="{path:'/home'}">首页</el-breadcrumb-item>
                    <el-breadcrumb-item :to="{path:'/communication'}">交流中心</el-breadcrumb-item>
                    <el-breadcrumb-item>示范留言</el-breadcrumb-item>
                </el-breadcrumb>
            </div>
            <div class="c-d-b">
                <div class="content">
                    <p class="p1">{{detail.titleName}}</p>
                    <div class="c-i">
                        <p class="p2"><span style="padding-right:20px;">示范类型</span>{{detail.sfType_text}}</p>
                        <p class="p2"><span style="padding-right:20px;">设备类型</span>{{detail.deviceTypeCode_text}}</p>
                        <!-- <p class="p2"><span style="padding-right:20px;">用户名</span>健康卡接口</p> -->
                        <p class="p2"><span style="padding-right:45px;">地域</span>{{detail.province_text}}{{detail.area_text}}</p>
                        <p class="p2"><span style="padding-right:20px;">机构</span>{{detail.orgCode_text}}</p>
                        <p class="p2"><span style="padding-right:20px;">文章类型</span>{{detail.isCopy_text}}</p>
                    </div>
                    <div class="c-h" >
                        <com-richtext :richtext="detail.content"></com-richtext>
                    </div>
                </div>

                <!-- 留言 -->
                <com-leave-word v-if="chatId" :chatId="chatId" :source="source"></com-leave-word>
            </div>
        </div>

    </div>
</template>
<script>
import CommunicationDetail from './CommunicationDetail.js';
export default CommunicationDetail;
</script>
<style lang="scss" scoped>
@import './CommunicationDetail.scss';
</style>